import React, { useEffect, useState } from 'react';
const trackFbEvent = (event: string, data?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
};
type Plan = 'megapack' | 'autoridad' | 'completo';
export function Pricing() {
  useEffect(() => {
    const section = document.getElementById('pricing');
    if (!section) return;
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        trackFbEvent('ViewContent', {
          content_name: 'Pricing Section',
          content_category: 'Nutrición Resuelta'
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.3
    });
    observer.observe(section);
    return () => observer.disconnect();
  }, []);
  const [selected, setSelected] = useState<Plan>('completo');
  const cartUrls: Record<Plan, string> = {
    megapack: 'https://www.bibliotecaprofesional.com/cart/48299487199402:1',
    autoridad: 'https://www.bibliotecaprofesional.com/cart/48299489689770:1',
    completo: 'https://www.bibliotecaprofesional.com/cart/48295641645226:1'
  };
  const plans: Record<Plan, {
    emoji: string;
    name: string;
    desc: string;
    priceOld: string;
    priceNew: string;
    priceColor: string;
    cta: string;
    sub: string;
    badge?: string;
  }> = {
    megapack: {
      emoji: '🥑',
      name: 'MEGAPACK NUTRICIÓN RESUELTA',
      desc: '6 Tomos clínicos + 6 Bonos estratégicos. El sistema base resuelto.',
      priceOld: '$34.990',
      priceNew: '$24.990',
      priceColor: 'text-gray-900',
      cta: '→ QUIERO EL MEGAPACK',
      sub: '6 Tomos · 6 Bonos · Acceso inmediato'
    },
    autoridad: {
      emoji: '⭐',
      name: 'AUTORIDAD NUTRICIONAL',
      desc: 'Todo lo anterior + 4 Tomos de especialización clínica y modelo de negocio.',
      priceOld: '$47.990',
      priceNew: '$32.990',
      priceColor: 'text-green-700',
      cta: '→ QUIERO AUTORIDAD NUTRICIONAL',
      sub: '6 Tomos · 6 Bonos · Upsell Clínico · Acceso inmediato',
      badge: '⭐ MÁS ELEGIDO'
    },
    completo: {
      emoji: '🏆',
      name: 'SISTEMA NUTRICIÓN COMPLETA',
      desc: 'Todo lo anterior + planillas, modelos editables e infraestructura operativa completa.',
      priceOld: '$54.990',
      priceNew: '$39.990',
      priceColor: 'text-green-700',
      cta: '→ QUIERO EL SISTEMA COMPLETO',
      sub: '6 Tomos · 6 Bonos · Upsell · Editables · Acceso inmediato',
      badge: '🏆 MÁS COMPLETO'
    }
  };
  const active = plans[selected];
  return <section id="pricing" className="w-full px-4 sm:px-6 lg:px-8 py-12 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(240,253,244) 15%, rgb(248,250,252) 85%, rgb(236,254,240) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-216">
      <div className="mx-auto max-w-3xl" data-id="element-217">

        {/* Heading */}
        <div className="text-center mb-8" data-id="element-218">
          <div className="inline-flex items-center gap-2 text-[11px] font-bold tracking-wide text-green-700 border border-green-700/40 bg-green-700/5 rounded-full px-4 py-1.5 mb-4" data-id="element-219">
            🔥 Precio de lanzamiento — Sube sin previo aviso
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-220">
            Elegí tu{' '}
            <span className="text-green-700" data-id="element-221">nivel del sistema:</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-222">
            Los 3 niveles incluyen los 6 Tomos + 6 Bonos estratégicos completos
          </p>
        </div>

        {/* Plan Selector */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-223">
          {(Object.keys(plans) as Plan[]).map(plan => {
          const p = plans[plan];
          const isSelected = selected === plan;
          return <button key={plan} onClick={() => setSelected(plan)} className={`w-full text-left rounded-xl p-4 transition-all cursor-pointer ${isSelected ? 'border-2 border-green-700 shadow-lg' : 'border border-gray-200 shadow-sm'}`} style={{
            backgroundColor: isSelected ? 'rgb(240, 253, 244)' : 'rgb(255,255,255)',
            boxShadow: isSelected ? 'rgba(34, 197, 94, 0.15) 0px 0px 30px 0px' : undefined
          }} data-id="element-224">
                <div className="flex items-center gap-3" data-id="element-225">
                  {/* Radio */}
                  <div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 ${isSelected ? 'border-green-700' : 'border-gray-300'}`} data-id="element-226">
                    {isSelected && <div className="h-2.5 w-2.5 rounded-full bg-green-700" data-id="element-227" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-228">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-229">
                      <span data-id="element-230">{p.emoji}</span>
                      <span className="text-sm font-black text-gray-900" data-id="element-231">
                        {p.name}
                      </span>
                      {p.badge && <span className="bg-green-700 text-[10px] font-black text-white rounded-full px-2 py-0.5" data-id="element-232">
                          {p.badge}
                        </span>}
                    </div>
                    <p className="text-xs text-gray-500 m-0" data-id="element-233">{p.desc}</p>
                  </div>

                  {/* Price */}
                  <div className="shrink-0 text-right" data-id="element-234">
                    <div className="text-xs text-gray-400 line-through" data-id="element-235">
                      {p.priceOld}
                    </div>
                    <div className={`text-2xl font-black ${p.priceColor}`} data-id="element-236">
                      {p.priceNew}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* CTA Block */}
        <div className="rounded-2xl p-5 shadow-lg" style={{
        background: 'linear-gradient(135deg, rgb(21,128,61), rgb(22,163,74))'
      }} data-id="element-237">
          {/* What you get summary */}
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mb-4" data-id="element-238">
            {active.sub.split(' · ').map(item => <span key={item} className="text-[11px] font-bold text-white/90 flex items-center gap-1" data-id="element-239">
                <span className="text-white/60" data-id="element-240">✓</span> {item}
              </span>)}
          </div>

          {/* Main CTA */}
          <a href={cartUrls[selected]} onClick={() => trackFbEvent('InitiateCheckout', {
          content_name: active.name,
          content_category: 'Nutrición Resuelta',
          value: selected === 'completo' ? 39990 : selected === 'autoridad' ? 32990 : 24990,
          currency: 'ARS'
        })} className="block w-full bg-white text-green-700 text-center text-sm sm:text-base font-black rounded-xl py-4 no-underline hover:bg-green-50 transition-colors" data-id="element-241">
            {active.cta}
          </a>

          {/* Subline */}
          <p className="text-center text-[11px] text-white/70 mt-3 mb-0" data-id="element-242">
            Más de 400 nutricionistas ya planifican con criterio y cobran lo que merecen
          </p>
        </div>

        {/* Trust Badges */}
        <div className="mt-4 flex flex-wrap items-center justify-center gap-3 text-xs text-gray-500 bg-white rounded-xl px-4 py-3 shadow-sm border border-gray-100" data-id="element-243">
          <span data-id="element-244">🔒 Pago seguro</span>
          <span data-id="element-245">⚡ Acceso en 5 min</span>
          <span data-id="element-246">🛡️ Garantía 7 días</span>
          <span data-id="element-247">💳 Mercado Pago</span>
        </div>

      </div>
    </section>;
}